@if (user) {
<div class="flex items-center">
    @if (showSummary) {
    <div class="hidden sm:flex flex-col mr-2 max-w-[320px] overflow-hidden"
        [ngClass]="summaryAlign === 'left' ? 'items-start text-left' : 'items-end text-right'">
        <span class="text-sm font-semibold leading-tight">{{displayName || 'Signed in'}}</span>
        @if (identityLabel) {
        <span class="text-xs text-secondary leading-tight break-all">{{identityLabel}}</span>
        }
        @if (rightsLabel) {
        <span class="text-xs text-secondary leading-tight uppercase">Rights: {{rightsLabel}}</span>
        }
    </div>
    }
    <!-- Button -->
    <button
        mat-icon-button
        [matMenuTriggerFor]="userActions">
        <span class="relative">
            <img
                class="w-7 h-7 rounded-full"
                *ngIf="showAvatar && user.avatar"
                [src]="user.avatar">
            <mat-icon
                *ngIf="!showAvatar || !user.avatar"
                [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            <span
                class="absolute right-0 bottom-0 w-2 h-2 rounded-full"
                [ngClass]="{'mr-px mb-px': !showAvatar || !user.avatar,
                              'bg-green-500': user.status === 'online',
                              'bg-amber-500': user.status === 'away',
                              'bg-red-500': user.status === 'busy',
                              'bg-gray-400': user.status === 'not-visible'}"
            ></span>
        </span>
    </button>
</div>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in</span>
            <span class="mt-1.5 text-md font-medium">{{user.firstName}} {{user.lastName}}</span>
            @if (identityLabel) {
            <span class="mt-1 text-xs text-secondary">Account: {{identityLabel}}</span>
            }
            @if (rightsLabel) {
            <span class="mt-1 text-xs text-secondary">Rights: {{rightsLabel}}</span>
            }
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button>
    <button
        mat-menu-item
        [matMenuTriggerFor]="userStatus">
        <mat-icon [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"></mat-icon>
        <span>Status</span>
    </button>
    <mat-divider class="my-2"></mat-divider> -->
    <button
        mat-menu-item
        (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>Sign out</span>
    </button>

    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="setAdminViewOverride('admin')">
        <mat-icon [svgIcon]="isAdminViewMode('admin') ? 'heroicons_solid:check-circle' : 'heroicons_outline:shield-check'"></mat-icon>
        <span>View as Admin</span>
    </button>
    <button
        mat-menu-item
        (click)="setAdminViewOverride('user')">
        <mat-icon [svgIcon]="isAdminViewMode('user') ? 'heroicons_solid:check-circle' : 'heroicons_outline:user'"></mat-icon>
        <span>View as Agent</span>
    </button>
    <button
        *ngIf="getAdminViewOverride()"
        mat-menu-item
        (click)="clearAdminViewOverride()">
        <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        <span>Clear View Override</span>
    </button>
</mat-menu>

<mat-menu
    class="user-status-menu"
    #userStatus="matMenu">
    <button
        mat-menu-item
        (click)="updateUserStatus('online')">
        <span class="w-4 h-4 mr-3 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('away')">
        <span class="w-4 h-4 mr-3 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('busy')">
        <span class="w-4 h-4 mr-3 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button
        mat-menu-item
        (click)="updateUserStatus('not-visible')">
        <span class="w-4 h-4 mr-3 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
}
